"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.caregiverTypeOptions = exports.statusFormOptions = exports.groupOptions = exports.statusOptions = exports.roleOptions = void 0;
const summithill_models_1 = require("@clearsummit/summithill-models");
const constants_1 = __importDefault(require("@/constants"));
const types_1 = require("./types");
exports.roleOptions = [
    {
        value: types_1.Groups.ALL,
        label: constants_1.default.manageAccounts.allRoles,
    },
    {
        value: types_1.Groups.ADMIN,
        label: constants_1.default.manageAccounts.admin,
    },
    {
        value: types_1.Groups.PATIENT,
        label: constants_1.default.manageAccounts.patient,
    },
    {
        value: types_1.Groups.CAREGIVER,
        label: constants_1.default.manageAccounts.caregiver,
    },
];
exports.statusOptions = [
    {
        value: types_1.Status.ALL,
        label: constants_1.default.manageAccounts.allStatus,
    },
    {
        value: types_1.Status.ACTIVE,
        label: constants_1.default.manageAccounts.active,
    },
    {
        value: types_1.Status.INACTIVE,
        label: constants_1.default.manageAccounts.inactive,
    },
];
exports.groupOptions = [
    {
        value: 1,
        label: constants_1.default.manageAccounts.admin,
        group: types_1.Groups.ADMIN,
    },
    {
        value: 2,
        label: constants_1.default.manageAccounts.caregiver,
        group: types_1.Groups.CAREGIVER,
    },
    {
        value: 3,
        label: constants_1.default.manageAccounts.patient,
        group: types_1.Groups.PATIENT,
    },
];
exports.statusFormOptions = [
    {
        id: 'active',
        label: constants_1.default.manageAccounts.create.active,
        ariaLabel: constants_1.default.manageAccounts.create.active,
        value: 'true',
    },
    {
        id: 'inactive',
        label: constants_1.default.manageAccounts.create.inactive,
        ariaLabel: constants_1.default.manageAccounts.create.inactive,
        value: 'false',
    },
];
exports.caregiverTypeOptions = [
    {
        value: summithill_models_1.CaregiverType.CASE_MANAGEMENT,
        label: constants_1.default.manageAccounts.create.caseManager2,
    },
    {
        value: summithill_models_1.CaregiverType.THERAPY,
        label: constants_1.default.manageAccounts.create.therapist2,
    },
];
